// import baseConfig from "../baseconfig.json";
// import config from "../config";
// export function shouldShowComponent(domain, componentName) {
//   return baseConfig.displayDomains[domain]?.includes(componentName);
// }

// export function hasFeature(featureName) {
//   return (
//     baseConfig.displayFeatures[
//       config.project
//     ]?.includes(featureName)
//   );
// }

const baseConfig = window.__BASE_CONFIG__ || {};

export function shouldShowComponent(domain, componentName) {
  return baseConfig.displayDomains?.includes(componentName) ?? false;
}

export function hasFeature(featureName) {
  return baseConfig.displayFeatures?.includes(featureName) ?? false;
}